var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-img',{attrs:{"src":_vm.data.img,"height":_vm.$vuetify.breakpoint.xs ? "150px" : "250px"}},[_c('div',{staticClass:"text-h6 data-text white--text"},[_vm._v(_vm._s(_vm.data.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }